<template>  
  <div class="portada-xv" ref="rootRef" aria-label="XV Cover"> 
 
    <!-- DECORATIVE FLOWERS --> 
    <img src="@/assets/monio.png" class="flor flor-1" alt="" /> 
    <img src="@/assets/flor1.png" class="flor flor-2" alt="" /> 
    <img src="@/assets/mari.png" class="flor flor-3" alt="" /> 
 
    <!-- 🦋 SIDE BUTTERFLIES --> 
    <img src="@/assets/mariposas.png" class="mariposa mariposa-1" alt="" /> 
    <img src="@/assets/mariposas.png" class="mariposa mariposa-2" alt="" /> 
    <img src="@/assets/mariposas.png" class="mariposa mariposa-3" alt="" /> 
    <img src="@/assets/mariposas.png" class="mariposa mariposa-4" alt="" /> 
    <img src="@/assets/mariposas.png" class="mariposa mariposa-5" alt="" /> 
    <img src="@/assets/mariposas.png" class="mariposa mariposa-6" alt="" /> 
 
    <!-- IMAGE WITH CROP + BOW --> 
    <div class="imagen-xv-shell"> 
      <div class="imagen-xv-wrapper"> 
        <img 
          src="@/assets/Gemini_Generated_Image_4xk7ng4xk7ng4xk7 (1).jpeg" 
          class="imagen-xv" 
          alt="Protagonist photo" 
        /> 
      </div> 
 
      <!-- 🎀 DECORATIVE BOW --> 
      <div class="mono-portada"> 
        <img 
          src="@/assets/mari.png" 
          class="mono-portada-img" 
          alt="Decorative bow" 
        /> 
      </div> 
    </div> 
 
    <!-- TEXT - Organized for consecutive entrance --> 
    <section class="texto-xv text-stagger-container"> 
      <p class="frase-bendicion text-anim-item"> 
      <br> <br>  With God's blessing and the love of my family, I celebrate a day that I will cherish forever in my heart.<br /><br /> 
        My parents: 
      </p> 
 
      <div class="separador-elegante text-anim-item"></div> 
 
      <!-- Parents' Names --> 
      <h1 class="nombre-protagonista text-anim-item">Fernando Enriquez</h1> 
      <h1 class="nombre-protagonista text-anim-item">Norma Calles</h1> 
 
      <div class="separador-elegante text-anim-item"></div> 
 
      <!-- Godparents' Names --> 
      <p class="frase-bendicion text-anim-item" style="margin-bottom: 5px;"> 
        My godparents: 
      </p> 
      <h1 class="nombre-protagonista text-anim-item">Gabriela Figueroa</h1> 
      <h1 class="nombre-protagonista text-anim-item">Darwin Escobar</h1> 
 
      <div class="separador-elegante text-anim-item"></div> 
 
      <p class="frase-bendicion text-anim-item"> 
        There are moments that define our lives, becoming forever etched in our souls and memories. 
        Today, I am living one of those special moments, and I want to share it with those 
        who hold a special place in my heart. 
      </p> 
    </section> 
  </div> 
</template>
<script>
import { onMounted, onUnmounted, ref, nextTick } from 'vue'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'PortadaArley',
  setup() {
    const rootRef = ref(null)
    let ctx = null

    onMounted(async () => {
      await nextTick()

      ctx = gsap.context(() => {
        const $ = (sel) => Array.from(gsap.utils.toArray(sel)).filter(Boolean)

        const foto = $('.imagen-xv-wrapper')
        const flores = ['.flor-1', '.flor-2', '.flor-3'].flatMap($)
        const mariposas = [
          '.mariposa-1',
          '.mariposa-2',
          '.mariposa-3',
          '.mariposa-4',
          '.mariposa-5',
          '.mariposa-6'
        ].flatMap($)
        const textoItems = $('.texto-xv .text-anim-item')

        // OPTIMIZACIÓN: Establecemos valores iniciales de desplazamiento y escala
        // para que las animaciones de entrada sean fluidas y utilicen la GPU.
        gsap.set(foto, { autoAlpha: 0, scale: 0.95, y: 30, force3D: true })
        gsap.set([...flores, ...mariposas], { autoAlpha: 0, scale: 0.85, y: 20, force3D: true })
        gsap.set(textoItems, { autoAlpha: 0, y: 20, force3D: true })

        // Animación de revelado ligera y única al llegar a la sección
        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: rootRef.value,
            start: 'top 85%',
            once: true // Se ejecuta una sola vez para no congelar el scroll
          }
        })

        // 1. Entrada de la Foto (Suavizada con power2.out)
        tl.to(foto, {
          autoAlpha: 1,
          scale: 1,
          y: 0,
          duration: 0.8,
          ease: 'power2.out'
        })

        // 2. Entrada de Flores
        .to(flores, {
          autoAlpha: 1,
          y: 0,
          scale: 1,
          rotate: (i) => [-2, -6, -4][i] || -4,
          stagger: 0.1,
          duration: 0.7,
          ease: 'power2.out'
        }, '-=0.5')

        // 3. Entrada de Mariposas
        .to(mariposas, {
          autoAlpha: 1,
          y: 0,
          scale: 1,
          stagger: 0.08,
          duration: 0.6,
          ease: 'power2.out'
        }, '-=0.5')

        // 4. Entrada de Textos (Stagger continuo)
        .to(textoItems, {
          autoAlpha: 1,
          y: 0,
          stagger: 0.08,
          duration: 0.6,
          ease: 'power2.out'
        }, '-=0.4')

        // Animación flotante ligera restringida para ahorrar GPU
        mariposas.slice(0, 3).forEach((m, i) => {
          gsap.to(m, {
            y: i % 2 === 0 ? -6 : 6,
            duration: 2.5 + i,
            yoyo: true,
            repeat: -1,
            ease: 'sine.inOut'
          })
        })

      }, rootRef.value)
    })

    onUnmounted(() => {
      if (ctx) ctx.revert()
    })

    return { rootRef }
  }
}
</script>

<style scoped>
/* OPTIMIZACIÓN: will-change ayuda al navegador a procesar animaciones en GPU */
.text-anim-item {
  will-change: transform, opacity;
}

.mariposa{
  position:absolute;
  width: 180px !important;;
  z-index:2;
  pointer-events:none;
  opacity:0;
  will-change: transform, opacity;
}

/* IZQUIERDA */
.mariposa-1{
  top:0%;
  left:-8%;
}

.mariposa-2{
  top:27%;
  left:-18%;
}

.mariposa-3{
  bottom:28%;
  left:-25%;
}

/* DERECHA */
.mariposa-4{
  top:20%;
  right:-8%;
  width: 0 !important;
}

.mariposa-5{
  top:45%;
  right:-18%;
    width: 0 !important;

}

.mariposa-6{
  bottom:25%;
  right:-18%;
}
.portada-xv{
  position:relative;
  width:100%;
  min-height:100vh;
  overflow:visible;
  display:flex;
  margin-top:0px;
  flex-direction:column;
  align-items:center;
  justify-content:flex-start;
  padding:0px 16px 56px;
}
.portada-xv::before{
  content: "";
  position: fixed; /* 🔥 efecto fixed real en móvil */
  inset: 0;

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  z-index: -1; /* detrás de todo */

  /* opcional: efecto elegante */
  transform: scale(1.05);
}
/* Marco con recorte superior redondeado (look luxury) */
.imagen-xv-wrapper{
  width: min(92vw, 360px);
  height: calc(min(92vw, 360px) * 1.5);
  margin-top: 86px;
  border-radius: 180px 180px 0 0;
  overflow: hidden;
  z-index: 2;
    background-position: center top;

  background:#fff;
  box-shadow:
    0 12px 40px rgba(0,0,0,.18),
    0 2px 8px rgba(0,0,0,.06);
  will-change: transform, filter, opacity;
  position: relative; /* para posicionar el moño dentro */
}
.imagen-xv{
  width:100%;
  height:100%;
  object-fit:cover;
  display:block;
}

/* 🎀 Moño en la parte superior derecha de la foto */
.mono-portada{
  position:absolute;
  top:-25px;
  right: -25px;
  z-index: 9995;
  z-index:1;
  transform: rotate(22deg);

}
.mono-portada-img{
  width: 240px;
  height: auto;
  display:block;
}

/* Texto */
.texto-xv{
  max-width: 620px;
  text-align:center;
  margin-top: -22px;
  padding: 0 8px;
}
.frase-destacada{
  font-family: "Playfair Display", serif;
  font-size: clamp(20px, 2.7vw, 28px);
  color:#2f2e2e;
  line-height:1.5;
  margin: 20px 0 10px;
}


/* ESTILOS DE TEXTO */
.frase-bendicion {
  font-family: "Playfair Display", serif;
  font-size: clamp(18px, 2.8vw, 22px);
  color: #3a3939;
  line-height: 1.6;
  margin: 0 0 15px;
}


.separador-elegante{ width:110px; height:2px; margin:12px auto 16px; background: linear-gradient(90deg, transparent, #d9b7c6, transparent); border-radius: 2px; }
.nombre-protagonista { font-family: "CynthiaJuneJF", cursive; font-size: 45px; margin: 0 0 8px 0; line-height: 1.5; background: linear-gradient(110deg, #a67c00 30%, #bf953f 45%, #ffffff 50%, #bf953f 55%, #a67c00 70% ); background-size: 200% auto; -webkit-background-clip: text; background-clip: text; color: transparent; filter: drop-shadow(0px 2px 3px rgba(0,0,0,0.5)); -webkit-font-smoothing: antialiased;  padding-right: 10px;}
.parrafo-presentacion{ font-family: "quote", sans-serif; font-size: clamp(16px, 2.6vw, 16px); color:#3d3c3c; line-height:1.7; margin-top: 6px; }

.nombre-protagonista2{
  font-family:"ludovica", cursive;
  font-size:52px !important;

  /* ✨ DORADO */
  background:linear-gradient(
    135deg,
    #4d3504 0%,
    #8c6510 12%,
    #c9961a 24%,
    #f0cf63 36%,
    #a87408 48%,
    #f5d46d 60%,
    #8b650d 76%,
    #4a3203 100%
  );

  background-size:220% auto;

  -webkit-background-clip:text;
  -webkit-text-fill-color:transparent;
  background-clip:text;
  color:transparent;

  margin:0 0 8px 0;
  line-height:1.8;

  filter:
    drop-shadow(0 1px 1px rgba(255,255,255,.15))
    drop-shadow(0 2px 8px rgba(120,80,0,.35));

  animation: brilloDorado 4s linear infinite;
}

/* ✨ BRILLO */
@keyframes brilloDorado{
  0%{
    background-position:0% center;
  }

  100%{
    background-position:220% center;
  }
}
.nombre-protagonista3{
  font-family: "titulos", cursive;
  font-size: 88px !important;
  color:#e5a3bb;
  margin: 0 0 8px 0;
  line-height:1.1;
}

.parrafo-presentacion{
  font-family: "quote", sans-serif;
  font-size: clamp(20px, 2.6vw, 17px) !important;
  color:#3d3c3c;
  line-height:1.7;
  margin-top: 10px;
}

/* FLORES */
.flor{
  position:absolute;
  width:min(44vw, 240px);
  z-index:10;
  transform-origin:center;
  will-change: transform, opacity;
}
.flor-1{
  top:20px;

  left:80%;
transform: translateX(-50%) rotate(13deg);
  z-index:9;

  width:min(64vw, 640px);
}.flor-2{ top:65px; left:-40px; transform: rotate(-80deg); z-index:-99 !important; width:min(40vw, 240px); }
.flor-3{ bottom:-90px; left:-100px; transform: rotate(-30deg); z-index:4;}

/* BOLA DISCO */
.bola{
  position:absolute;
  width:190px !important;
  animation: girar 10s linear infinite;
  opacity:.85;
  z-index:1;
  will-change: transform;
}
.bola-izquierda{ left:245px; bottom:-95px; z-index:9;   width:160px !important;
}
@keyframes girar {
  0% {
    transform: scale(1);
    opacity: 0.9;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.9;
  }
}

/* Responsive refinado */
@media (min-width: 992px){
  .imagen-xv-wrapper{ margin-top: 0; }
}

.ampersand{
  width:32px;

  height:auto;

  display:block;

  margin:0 auto;

  position:relative;

  z-index:5;

  opacity:0;

  filter:
    drop-shadow(0 2px 8px rgba(212,175,55,.35))
    drop-shadow(0 0 14px rgba(255,215,120,.18));
}

.ampersand-padres{
  margin-top:-2px;
  margin-bottom:4px;
}

.ampersand-padrinos{
  margin-top:-2px;
  margin-bottom:4px;
}
</style>